import { render, staticRenderFns } from "./preview-payment.vue?vue&type=template&id=723db95d"
import script from "./preview-payment.vue?vue&type=script&lang=js"
export * from "./preview-payment.vue?vue&type=script&lang=js"
import style0 from "./preview-payment.vue?vue&type=style&index=0&id=723db95d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports